import React, { useState } from "react";
import { Control, Controller, ControllerRenderProps } from "react-hook-form";

import { Switch, ISwitchProps } from "../inputs/switch/Switch";

export interface FormSwitchProps extends ISwitchProps {
    label: string;
    name: string;
    control: Control;
    check?: boolean;
}

export const FormSwitch: React.VFC<FormSwitchProps> = ({ label, name, control, check, onChange }: FormSwitchProps) => {
    const [isChecked, setIsChecked] = useState<boolean>(check ?? false);

    const render = (prop: ControllerRenderProps<Record<string, unknown>>) => {
        const handleSwitchValueChange = (_ev?: React.MouseEvent<HTMLElement> | undefined, checked?: boolean) => {
            setIsChecked(!!checked);
            prop.onChange(!!checked);
            if (_ev) {
                onChange?.(_ev);
            }
        };
        return <Switch label={label} onChange={handleSwitchValueChange} checked={prop.value || isChecked} />;
    };
    return <Controller name={name} control={control} render={render} />;
};
